export default "/images/69343e5c846b16e59fd37c8c110af328.avif";